// $('.select--proneft').select2({
// 	minimumResultsForSearch: -1,
// 	dropdownParent: $('.proneft-search')
// });

$('.proneft-search').on('submit', function (e) {
	e.preventDefault();
	window.location = `/search/?${$(this).serialize()}`;
});



// WEBPACK FOOTER //
// ./frontend/components/proneft-search/proneft-search.js